<template>
    <div class="shop_foot">
        <div class="lxfs-warp">
            <!-- 联系方式 -->
            <div class="lxfs-warp-title">
                <!-- 左侧二维码 -->
                <div class="lxfs_left" style="margin-left:3%;">
                    <div>
                        <img src="../../src/imges/top/QRCode/gzh.png" alt="海工人官方公众号">
                        <div style="font-size:0.8rem;margin-top:6px;">海工人官方公众号</div>
                    </div>
                    <div>
                        <img src="../../src/imges/top/QRCode/sjd.png" alt="海工人官方手机网">
                        <div style="font-size:0.8rem;margin-top:6px;">海工人官方手机网</div>
                    </div>
                    <div>
                        <img src="../../src/imges/top/QRCode/dyh.png" alt="海工人官方抖音号">
                        <div style="font-size:0.8rem;margin-top:6px;">海工人官方抖音号</div>
                    </div>
                </div>
                <div class="lxfs_sx"></div>
                <!-- 右侧联系方式 -->
                <div class="lxfs_right">
                    <!-- 联系方式 -->
                    <div class="lxfs_right_kf">
                        <div class="lxfs_right_kf1">
                           <div class="lxfs_img___">
                               <img src="../../src/imges/apsa/zxkf.png" alt="">
                           </div>
                           <div class="lxfs_text___1">
                               <div class="kf">在线客服</div>
                               <div class="jt1" @click="jtnmb">开始交谈</div>
                           </div>
                        </div>
                        <div class="lxfs_right_kf2">
                           <div class="lxfs_img___">
                               <img src="../../src/imges/apsa/dhtz.png" alt="">
                           </div>
                           <div class="lxfs_text___1">
                               <div class="kf">服务热线</div>
                               <div class="jt">021-59142813</div>
                           </div>
                        </div>
                        <div class="lxfs_right_kf3" style="">
                           <div class="lxfs_img___">
                               <img src="../../src/imges/apsa/yja.png" alt="">
                           </div>
                           <div class="lxfs_text___1">
                               <div class="kf">邮箱地址</div>
                               <div class="jt">shipoe360@163.com</div>
                           </div>
                        </div>
                        <div class="lxfs_right_kf4">
                            <div class="lxfs_img___">
                                <img src="../../src/imges/apsa/hyhd.png" alt="">
                            </div>
                           <div class="lxfs_text___1">
							   <div class="kf">会员申请</div>
							   <router-link class="jt" to="/register" style="text-decoration: none;margin-top: 5px;color: #000000;display: block;">点击申请</router-link>
						   </div>
                        </div>
                    </div>
                    <!-- 底部小导航 -->
<!--                    <div style="margin:26px 0;font-size: 14px;">-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;"-->
<!--								:to="{path: '/about'}"-->
<!--							>-->
<!--								关于我们-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/gghz'}"-->
<!--							>-->
<!--								广告合作-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/swhza'}"-->
<!--							>-->
<!--								商务合作-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/zpxxa'}"-->
<!--							>-->
<!--								招聘信息-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/lxwma'}"-->
<!--							>-->
<!--								联系我们-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/hyfwa'}"-->
<!--							>-->
<!--								会员服务-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/yhxya'}"-->
<!--							>-->
<!--								用户协议-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/tsjya'}"-->
<!--							>-->
<!--								投诉建议-->
<!--							</router-link>-->
<!--							<router-link-->
<!--							style="text-decoration: none; color: #000;margin-left: 8px;"-->
<!--								:to="{path: '/yszca'}"-->
<!--							>-->
<!--								隐私政策-->
<!--							</router-link>-->
<!--                    </div>-->
                    <!-- 合作伙伴 -->

                </div>
            </div>
			<div class="lxfs-warp-title">
				<div class="yqlj_warp_">
				    合作伙伴
				</div>
			    <ul id="computses" class="hzhb_warp">
					<li v-for="(item,index) in qwqe" :key="index">
						<a class="qwqerty" :href="item.frelink" style="color: #000000;">{{item.title}}</a>
					</li>
			    </ul>
			</div>
            <!-- 友情链接 -->
            <div class="lxfs-warp-title">
                <div class="yqlj_warp_">
                    友情链接
                </div>
                <ul id="computses" class="hzhb_warp">
					<li v-for="(item,index) in qwqa" :key="index">
						<a class="qwqerty" :href="item.frelink" style="color: #000000;">{{item.title}}</a>
					</li>
                </ul>
            </div>
        </div>
        <div class="foot_copyright">
            <p style="color:#fff;">Copyright © 2014 谐通船舶海洋工程技术(上海)有限公司. All Rights Reserved</p>
            <p style="color:#fff;">沪公网 31011402002790号 | 出版物经营许可证沪零字第M6399号 | ICP备案号：<a  style="color:#fff;" href="https://beian.miit.gov.cn"> 沪ICP备14034676号-2</a> | 海工人法律顾问单位：北京市中闻（上海）律师事务所 / 高级合伙人 / 傅兵先生</p>
        </div>
    </div>
</template>

<script>
	import http from "@/utils/http";
export default {
    data() {
      return {
		  qwqe:'',
		  qwqa:'',
          adv:{},
          info:{},
      };
    },
    methods: {
		jtnmb(){
			window.open('https://admin.shipoe360.com/kf/zaixian.html','_href')
		},
       
    },
    async mounted() {
		
		let res = await http.post('api/Common/index',{
			model:'friend_link',
			type:'content',
			mid:'5',
			rows_limit:'99'
		})
		
		let res1 = await http.post('api/Common/index',{
			model:'friend_link',
			type:'content',
			mid:'6',
			rows_limit:'99'
		})
		this.qwqa = res.data.data.list.data
		this.qwqe = res1.data.data.list.data
		
	}
};
</script>


<style>
	*{
		text-decoration: none;
	}
	

.shop_foot{
  margin-top: 40px;
}
.foot_copyright{
	text-align: center;
     background-color: #F54E39;
     clear: both;
     font-size: 12px;
     line-height: 27px;
     padding-top: 10px;
     padding-bottom: 10px;
}
.lxfs-warp{
    margin: 0 auto;
    overflow: hidden;
	background-color: #FFF;
}
@media screen and (max-width: 1300px) {

    .lxfs-warp {
        width: 100%;
    }
    
}
.hzhb_warp::after,
.lxfs_right_kf::after,
.lxfs_right_kf > div::after,
.lxfs_left::after,
.lxfs-warp-title::after{
    content: '';
    display: block;
    clear: both;
}

router-link{
	text-decoration: none;
}

.yqlj_warp_{
    width: 100%;
    font-size: 18px;
    border-bottom: 2px solid #f54e39;
    margin-bottom: 16px;
    text-align: left;
    padding-left: 20px;
    padding-bottom: 8px;
}

.lxfs-warp-title{
    padding-top: 10px; 
}
.lxfs-warp-title .lxfs_sx{
  margin-top: 0px;
      margin-left: 2%;
      margin-right: 2%;
      height: 130px;
      border-right: 1px solid #cacaca;
}
.lxfs-warp-title .lxfs_left{
    width: 33%;
}
.lxfs-warp-title .lxfs_left > div{
  position: relative;
  margin: 0 14px;
  float: left;
  width: 26%;
  padding: 12px 0;
}
.lxfs-warp-title .lxfs_left > div  img{
  width: 90%;
  height: 90px;
}
.lxfs_right{
  width: 57%;
  margin-top: 20px;
}

        
.lxfs_right .zxkf_right_kf{
  width:120px;
  height:45px;
  cursor: pointer;
}
.lxfs_right  .zxkf_right_kf1{
  width:50%;
  height:48px;
  margin-left: 3%;
}
.lxfs_right  .zxkf_right_kf1  img{
  width: 100%;
  height: 100%;
}
.lxfs_right_kf > div{
    float: left;
    margin-right: calc((100% - 628px) / 4);
}
.lxfs_right_kf1{
    width: 138px;
}
.lxfs_right_kf2{
    width: 160px;
}
.lxfs_right_kf3{
    width: 200px;
}
.lxfs_right_kf4{
    width: 130px;
}
.lxfs_img___{
    float: left;
    width: 50px;
    height: 50px;
}
.lxfs_text___{
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    text-align: left;
    margin-left: 10px;
}
.lxfs_text___1{
    float: left;
	font-size: 12px;
}
.lxfs_text___1 .kf{
    font-size: 16px;
    text-align: left;
    margin-left: 10px;
    margin-top: 2px;
}
.jt{
  margin-left: 10px;  
  margin-top: 5px;
}
.jt1{
	margin-top: 5px;
    border: 1px solid #CA151E;
    color: #CA151E;
    border-radius: 20px;
    margin-left: 6px;
    padding: 0px 6px;
    font-size: 13px ;
}
.lxfs_img___ > img{
    width: 100%;
    height: 100%;
}
.lxfs-warp-title > div{
    float: left;
}
.hzhb_warp{
  list-style: none;
  width: 100%;
  
}


.hzhb_warp li{
  float: left;
  margin-right: 18px;
  font-size: 13px;
  line-height: 20px;
  color: #595959;
  -webkit-transform: scale(0.90);
}

#computses{
	padding: 0px;
}

</style>